import React from "react";
import { jointImg } from "@/lib/commonService";
import stl from "./productInTable.module.scss";
import getWebpUrl from "@/src/utils/getWebpUrl";
import { FmImage } from "@/ui-component";
import ProductItemClient from "./ProductItemClient";
interface Props {
    data: any;
    type: string;
}

const ProductItem: React.FC<Props> = (props) => {
    const { data } = props;

    return (
        <div className={stl["like-product-item"]}>
            <ProductItemClient {...props}>
                <FmImage
                    height={250}
                    image={jointImg({
                        productId: data.products_id,
                        size: "middle",
                        imgTotal: 2,
                        name: data.products_image,
                    })}
                    style={{
                        minHeight: "1.5rem",
                    }}
                />

                <span className={stl["products_name"]}>
                    {data.products_name_attribute || data.products_model}
                </span>
            </ProductItemClient>
        </div>
    );
};

export default ProductItem;
